import React from 'react';
import { get } from 'lodash';
import { TextField, FunctionField } from 'react-admin';

import { List, Datagrid } from 'components/list';
import { ActionField } from 'components/fields';
import EditTierField from './components/EditTierField';
import { formatCentsPrice } from 'services/helpers/formatPrice';

const FormattedPriceField = (props) => {
  return (
    <FunctionField
      {...props}
      render={(record) => {
        return formatCentsPrice(get(record, props.source, 0));
      }}
    />
  );
};

const AchTiersList = (props) => {
  return (
    <List pagination={null} {...props}>
      <Datagrid rowClick="show">
        <TextField source="tier" label="Tier #" />
        <FormattedPriceField
          source="instantAvailabilityCapCents"
          label="Instant availability cap"
        />
        <TextField source="minSuccessfulClearancesToPromote" label="Min successful clearances" />
        <FormattedPriceField source="minDynamicCapCents" label="Min dynamic cap" />
        <FormattedPriceField source="maxDynamicCapCents" label="Max dynamic cap" />

        <ActionField>
          <EditTierField />
        </ActionField>
      </Datagrid>
    </List>
  );
};

export default AchTiersList;
